import { render, staticRenderFns } from "./CowScreening.vue?vue&type=template&id=16bd16dc&scoped=true&"
import script from "./CowScreening.vue?vue&type=script&lang=js&"
export * from "./CowScreening.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bd16dc",
  null
  
)

export default component.exports